import { render, staticRenderFns } from "./DoorColor.vue?vue&type=template&id=e27b27ac&"
import script from "./DoorColor.vue?vue&type=script&lang=js&"
export * from "./DoorColor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports